import React, { useEffect, useRef } from 'react';
import Snowfall from './components/Snowfall';
import './App.css';

function App() {
  const canvasRef = useRef(null);
  const gameInitializedRef = useRef(false);

  useEffect(() => {
    // Wait for DOM to be fully loaded
    const initializeGame = () => {
      if (!gameInitializedRef.current && window.initGame) {
        window.initGame();
        gameInitializedRef.current = true;

        // Ensure event listeners are attached
        const addGameListeners = () => {
          document.addEventListener('keydown', (e) => {
            if (window.handleKeyDown) {
              window.handleKeyDown(e);
            }
          });

          document.addEventListener('keyup', (e) => {
            if (window.handleKeyUp) {
              window.handleKeyUp(e);
            }
          });

          // Add click listeners to mode buttons
          document.querySelectorAll('.mode-btn').forEach(btn => {
            btn.addEventListener('click', () => {
              if (window.handleModeSelection) {
                window.handleModeSelection(btn.dataset.mode);
              }
            });
          });
        };

        // Add listeners after a short delay to ensure DOM is ready
        setTimeout(addGameListeners, 100);
      }
    };

    // Try to initialize immediately
    initializeGame();

    // Fallback: try again after a short delay if needed
    const initTimeout = setTimeout(initializeGame, 500);

    return () => {
      clearTimeout(initTimeout);
      if (window.cleanupGame) {
        window.cleanupGame();
      }
      gameInitializedRef.current = false;
    };
  }, []);

  const handleRestart = () => {
    if (window.handleRestartGame) {
      window.handleRestartGame();
    }
  };

  return (
    <div className="game-container">
      <Snowfall />
      <button 
        className="restart-btn" 
        onClick={handleRestart}
        style={{
          position: 'fixed',
          top: '20px',
          right: '200px',
          padding: '10px 20px',
          fontSize: '16px',
          backgroundColor: '#FF0000',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          zIndex: 1000,
          fontFamily: '"Fredoka One", cursive',
          boxShadow: '0 0 10px rgba(0,0,0,0.5)'
        }}
      >
        Restart
      </button>
      <canvas id="gameCanvas" ref={canvasRef}></canvas>
      <div className="start-screen" id="startScreen">
        <h1 className="game-title">Santa's Magical Adventure!</h1>
        <div className="mode-selection">
          <button className="mode-btn" data-mode="EASY" type="button">
            Easy
            <span className="arrow-keys">← →</span>
          </button>
          <button className="mode-btn" data-mode="MEDIUM" type="button">
            Medium
            <span className="arrow-keys">← →</span>
          </button>
          <button className="mode-btn" data-mode="HARD" type="button">
            Hard
            <span className="arrow-keys">← →</span>
          </button>
        </div>
        <p className="start-message">Select Mode and Press SPACE to Start!</p>
        <div className="controls-info">
          <p>⬆️ Hold to Fly/Glide | ⬇️ Fast Fall</p>
          <p>⬅️ ➡️ Steer Santa's Sleigh</p>
          <p>Collect presents and avoid obstacles!</p>
        </div>
      </div>
    </div>
  );
}

export default App; 